import React from "react";
import { Box, Typography } from "@mui/material";
import I18n from "i18next";
import MzButton from "@markaaz/ui/MzButton";

const sx = {
  container: {
    marginTop: "20px",
    width: "465px"
  },
  rowContainer: {
    minHeight: "70px",
    bgcolor: "background.paper",
    padding: "20px",
    borderBottom: "1px solid var(--blue-20, #CEE4F5)",
    "&:first-child": {
      borderTopLeftRadius: "8px",
      borderTopRightRadius: "8px"
    },
    "&:last-child": {
      borderBottom: "none",
      borderBottomLeftRadius: "8px",
      borderBottomRightRadius: "8px"
    }
  },
  rowText: {
    color: "darkBlue.c100",
    textTransform: "uppercase",
    fontWeight: 600,
    marginBottom: "8px"
  },
  keys: {
    display: "flex",
    width: "425px",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "15px",
    color: "blue.c100",
    svg: {
      color: "blue.c100"
    }
  },
  desc: {
    color: "darkBlue.c100",
    marginBottom: "20px"
  }
};

const AdministrationMain = ({ dataList }) => {
  return (
    <Box>
      <Box sx={sx.container}>
        {dataList.map((datum, i) => {
          return (
            <Box key={datum.label} sx={sx.rowContainer}>
              <Typography variant="body2" sx={sx.rowText}>
                {datum.label}
              </Typography>
              <Typography variant="body2" sx={sx.desc}>
                {datum.desc}
              </Typography>
              <Box sx={sx.keys}>
                <Typography variant="body2" sx={{ textAlign: "right" }}>
                  {datum.value}
                </Typography>
                {datum.icon}
              </Box>
            </Box>
          );
        })}
      </Box>
      <MzButton
        variant="contained"
        size="large"
        sx={{ marginTop: "50px" }}
        href="https://developer.markaaz.com/"
        target="_blank"
      >
        {I18n.t("accessAdministration.goToDeveloperPortal")}
      </MzButton>
    </Box>
  );
};

export default AdministrationMain;
